__turbopack_context__.v({
  "list": "list-module-scss-module__1ZD15q__list",
});
